import { AdminAppState, EventEntry } from '../../state';
import { getEvent } from './get-event';

export const getEventPageId = (eventKey: string) => (
  store: AdminAppState,
): EventEntry['event']['pageId'] => getEvent(eventKey)(store).pageId;
